<template>
    <div class="secondary-padding py-3">
        <div class="airportia-title d-flex flex-wrap justify-content-between mt-4">
            <label class="align-self-center mb-4">{{title}}</label>

            <div class="d-flex mb-1">
                <label class="align-self-center filter">{{filterText}}</label>
                <a class="btn tag" :class="{'secondary': iframe == 'arrivals', 'primary':  iframe != 'arrivals'}" @click.prevent="changeIframe('arrivals')">
                    <div class="align-self-center" v-html="arrivalsText"></div>
                </a>
                <a class="btn tag" :class="{'secondary': iframe == 'departures', 'primary':  iframe != 'departures'}" @click.prevent="changeIframe('departures')">
                    <div class="align-self-center" v-html="departuresText"></div>
                </a>
            </div>
        </div>
        <div class="airportia-widget">
            <iframe
                scrolling="no"
                frameborder="0"
                style="border:0; width: 100%; height: 95%; min-height: 650px; margin:0; padding:0;"
                :src="`https://www.airportia.com/widgets/airport/cun/${iframe}/?df=dmy`">
            </iframe>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        title: String,
        filterText: String,
        arrivalsText: String,
        departuresText: String
    },
    data: () => ({
        iframe: 'arrivals'
    }),
    methods: {
        changeIframe(iframe) {
            this.iframe = iframe;
        }
    }
}
</script>
<style lang="scss" scoped>
.filter {
    color: #575A60;
    font-size: 16px;
    margin-right: 1rem;
}

.tag {
    font-size: 16px;
    margin-bottom: 0rem;
}
</style>
<style lang="scss">
p {
    margin-bottom: 0rem!important;
}
</style>